import React, { useState } from 'react';
import styled from 'styled-components'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import KidBalance from './KidBalance';


const EconomyViewStyled = styled.div`
    height: 100%;
    width: 100%;
`;

const ContainerStyled = styled(Container)`
    height: 100%;
`;

const RowStyled = styled(Row)`
    height: 100%;
`;

const ColStyled = styled(Col)`
    border-right: 1px solid gray;
`;

const EconomyOverview = ({ refreshTrigger }) => {

    const [loading, setLoading] = useState(false);

    return (
        <EconomyViewStyled>
            <ContainerStyled>
                <RowStyled>
                    <ColStyled><KidBalance kidName='Sivert' refreshTrigger={refreshTrigger} /></ColStyled>
                    <ColStyled><KidBalance kidName='Jenny' refreshTrigger={refreshTrigger} /></ColStyled>
                </RowStyled>
            </ContainerStyled>
        </EconomyViewStyled>
    );
};

export default EconomyOverview;